module.exports = __webpack_public_path__ + "static/office-a5fa5f6e32e606bf5c1a87acc9b6f9f7.jpg";